const appUrl = process.env.NEXT_PUBLIC_SITE_URL;
const serviceDomain = process.env.NEXT_PUBLIC_WEB_SERVICES_DOMAIN;

export const HeaderFooterApiEndpoints = {
  HEADER_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/in/en/xaop-header/master/master.headless.json`,
  HAMBURGER_MENU_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/in/en/xaop-header/hamburger/master.headless.json`,
  MOB_HEADER_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/app-v1/en/xaop-header/single-pdp-app-header/master.headless.json`,
  MOB_BOTTOM_NAV_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/app-v1/en/xaop-header/single-pdp-app-header/master.headless.json`,
  FOOTER_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/in/en/xaop-footer/footer/master.headless.json`,
  MOB_FOOTER_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/app-v1/en/xaop-header/single-pdp-app-header/master.headless.json`,
  SEARCH_CONTENT: `${serviceDomain}/api/v5/autocomplete`,
};
